import globals from '../../../components/PageBuilder/globals';
import api from '../../../mdms_api';

export default async (asset_uuid) => {
  const { PB_SITE } = globals();
  const url = `/api/v1/cms/sites/${PB_SITE}/assets/${asset_uuid}`;
  const response = await api.get(url)
  return await response.json();
};
